import LayoutContainer from './layout-container';
import kaerPage from './page';

const components = [
  LayoutContainer,
  kaerPage
];

const install = function(Vue) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

export default { install };
